/**
 * Alumenarc Premium Metallic Transition
 * TRUE APP-LIKE SEAMLESS VERSION
 * 
 * Strategy: Load next page in hidden iframe during animation,
 * then fade out overlays to reveal the loaded page
 */

(function() {
  'use strict';

  let isAnimating = false;
  let scene, camera, renderer, animationId;
  let cachedEnvTexture = null;

  const SETTINGS = {
    imageBrightness: 1.6,
    reflectionBrightness: 1.3,
    reflectivity: 0.3,
    shineIntensity: 0.05,
    environment: 'bridge',
    
    // Timing for seamless transition
    animationDuration: 1200,
    fadeOutStart: 1000,
    fadeOutDuration: 400
  };

  // Public API
  window.AlumenarcTransition = {
    trigger: function(productUrl, sourceImg) {
      if (!isAnimating && sourceImg && sourceImg.complete && sourceImg.naturalHeight !== 0) {
        startTransition(productUrl, sourceImg);
      }
    }
  };

  // Custom event listener
  document.addEventListener('alumenarc-transition', function(e) {
    if (e.detail && e.detail.url && e.detail.image) {
      window.AlumenarcTransition.trigger(e.detail.url, e.detail.image);
    }
  });

  // Extract dominant color
  function extractDominantColor(img) {
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = 50;
      canvas.height = 50;
      ctx.drawImage(img, 0, 0, 50, 50);
      
      const imageData = ctx.getImageData(0, 0, 50, 50).data;
      let r = 0, g = 0, b = 0, count = 0;
      
      for (let i = 0; i < imageData.length; i += 4) {
        const brightness = (imageData[i] + imageData[i + 1] + imageData[i + 2]) / 3;
        if (brightness > 20 && brightness < 235) {
          r += imageData[i];
          g += imageData[i + 1];
          b += imageData[i + 2];
          count++;
        }
      }
      
      if (count === 0) {
        r = g = b = 100;
        count = 1;
      }
      
      r = Math.floor(r / count);
      g = Math.floor(g / count);
      b = Math.floor(b / count);
      
      return {
        light: `rgba(${r}, ${g}, ${b}, 0.6)`,
        medium: `rgba(${Math.floor(r * 0.7)}, ${Math.floor(g * 0.7)}, ${Math.floor(b * 0.7)}, 0.4)`,
        dark: `rgba(${Math.floor(r * 0.4)}, ${Math.floor(g * 0.4)}, ${Math.floor(b * 0.4)}, 0.3)`
      };
    } catch (error) {
      return {
        light: 'rgba(100, 100, 100, 0.6)',
        medium: 'rgba(70, 70, 70, 0.4)',
        dark: 'rgba(40, 40, 40, 0.3)'
      };
    }
  }

  // Load HDR environment
  // Load HDR Environment - OPTIMIZED: Single face on mobile for 6x speed boost
  function loadGoogleHDR(envName) {
    const isMobile = window.innerWidth <= 768;
    
    if (isMobile) {
      // MOBILE: Only load FRONT face - saves 2.5MB, 6x faster!
      let frontUrl;
      
      switch(envName) {
        case 'park':
          frontUrl = 'https://threejs.org/examples/textures/cube/Park3Med/px.jpg';
          break;
        default: // bridge - self-hosted compressed
  frontUrl = 'https://cdn.shopify.com/s/files/1/0640/6956/6616/files/bridge2posz_1.jpg?v=1776679157';
  break;
      }
      
      // Load single image, duplicate for all cubemap faces
      const cubeTexture = new THREE.CubeTextureLoader().load([
        frontUrl, frontUrl, frontUrl, frontUrl, frontUrl, frontUrl
      ]);
      cubeTexture.format = THREE.RGBFormat;
      return cubeTexture;
      
    } else {
      // DESKTOP: Full 6-face cubemap
      let path, urls;
      
      switch(envName) {
        case 'park':
          path = 'https://threejs.org/examples/textures/cube/Park3Med/';
          urls = [path + 'px.jpg', path + 'nx.jpg', path + 'py.jpg', path + 'ny.jpg', path + 'pz.jpg', path + 'nz.jpg'];
          break;
        default: // bridge - single face only, duplicated
  const bridgeFront = 'https://cdn.shopify.com/s/files/1/0640/6956/6616/files/bridge2posz_1.jpg?v=1776679157';
  urls = [bridgeFront, bridgeFront, bridgeFront, bridgeFront, bridgeFront, bridgeFront];
  break;t5
      }
      
      const cubeTexture = new THREE.CubeTextureLoader().load(urls);
      cubeTexture.format = THREE.RGBFormat;
      return cubeTexture;
    }
  }

  function waitForThree(callback) {
    if (typeof THREE !== 'undefined') {
      callback();
    } else {
      setTimeout(() => waitForThree(callback), 50);
    }
  }

  // Click interceptor
  document.addEventListener('click', function(e) {
    if (isAnimating) return;
    
    const link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    
    let productCard = link.closest('product-card, .product-card, product-card-link, resource-card, .resource-card, [data-product-id]');
    
    if (!productCard) {
      const cardGallery = link.closest('.card-gallery');
      if (cardGallery) {
        productCard = cardGallery.closest('product-card, .product-card, resource-card, .resource-card, [data-product-id]');
      }
    }
    
    if (productCard) {
      let img = productCard.querySelector('img[data_product_image="true"]');
      if (!img) img = productCard.querySelector('img');
      
      if (img && img.complete && img.naturalHeight !== 0) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        
        // Smart quality selection
        const isMobile = window.innerWidth <= 768;
        
        // Mobile: ALWAYS use 1024x1024 (crisp on all Samsung/iPhone)
        // Desktop: Calculate based on screen size
        let targetSize;
        if (isMobile) {
          targetSize = '1024x1024'; // Fixed size for mobile - fast & crisp
        } else {
          // Desktop: calculate ideal size
          const displaySize = window.innerWidth * 0.4;
          const idealSize = Math.ceil(displaySize * window.devicePixelRatio);
          
          if (idealSize <= 480) {
            targetSize = '480x480';
          } else if (idealSize <= 720) {
            targetSize = '720x720';
          } else if (idealSize <= 1024) {
            targetSize = '1024x1024';
          } else if (idealSize <= 1440) {
            targetSize = '1440x1440';
          } else {
            targetSize = '2048x2048';
          }
        }
        
        
        // Get base image URL
        const baseSrc = img.getAttribute('src') || img.src;
        const currentWidth = img.naturalWidth;
        const currentHeight = img.naturalHeight;
        
        
        // Extract target width from targetSize (e.g., "1024x1024" -> 1024)
        const targetWidth = parseInt(targetSize.split('x')[0]);
        const needsBetter = currentWidth < targetWidth;
        
        
        if (needsBetter && baseSrc.includes('shopify.com')) {
          // Load better quality image
          const highQualityImg = new Image();
          highQualityImg.crossOrigin = 'anonymous';
          
          // Replace size parameter or add it
          let optimizedSrc;
          if (baseSrc.match(/_\d+x\d+/)) {
            // Replace existing size
            optimizedSrc = baseSrc.replace(/_\d+x\d+/, '_' + targetSize);
          } else {
            // Add size before extension
            optimizedSrc = baseSrc.replace(/(\.(jpg|jpeg|png|webp))/i, '_' + targetSize + '$1');
          }
          
          
          highQualityImg.src = optimizedSrc;
          
          // Longer timeout for mobile (500ms)
          const loadTimeout = setTimeout(() => {
            startTransition(link.href, img);
          }, 500);
          
          highQualityImg.onload = function() {
            clearTimeout(loadTimeout);
            startTransition(link.href, highQualityImg);
          };
          
          highQualityImg.onerror = function() {
            clearTimeout(loadTimeout);
            startTransition(link.href, img);
          };
        } else {
          // Current image is good enough
          startTransition(link.href, img);
        }
        
        return false;
      }
    }
  }, true);

  function startTransition(productUrl, sourceImg) {
    isAnimating = true;
    
    if (typeof THREE !== 'undefined') {
      playMetallicTransition(productUrl, sourceImg);
    } else {
      playFallbackTransition(productUrl, sourceImg);
    }
  }
  
  function playMetallicTransition(productUrl, sourceImg) {
    const ambientColor = extractDominantColor(sourceImg);
    
    // Prefetch the page immediately - browser will cache it
    const prefetchLink = document.createElement('link');
    prefetchLink.rel = 'prefetch';
    prefetchLink.href = productUrl;
    document.head.appendChild(prefetchLink);
    
    
    // Frosted glass blur layer
    const blurLayer = document.createElement('div');
    blurLayer.className = 'alumenarc-overlay';
    blurLayer.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      backdrop-filter: blur(40px) saturate(150%);
      -webkit-backdrop-filter: blur(40px) saturate(150%);
      background: rgba(0, 0, 0, 0.5);
      z-index: 99997;
    `;
    document.body.appendChild(blurLayer);
    
    // Ambient glow
    const ambientBackground = document.createElement('div');
    ambientBackground.className = 'alumenarc-overlay';
    ambientBackground.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: radial-gradient(ellipse at center, 
        ${ambientColor.light} 0%, 
        ${ambientColor.medium} 30%, 
        ${ambientColor.dark} 60%, 
        transparent 100%);
      z-index: 99998;
      opacity: 0;
      transition: opacity 600ms ease;
      pointer-events: none;
    `;
    document.body.appendChild(ambientBackground);
    
    setTimeout(() => { ambientBackground.style.opacity = '1'; }, 50);
    
    // Three.js overlay
    const overlay = document.createElement('div');
    overlay.className = 'alumenarc-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      z-index: 99999;
      transition: opacity ${SETTINGS.fadeOutDuration}ms ease;
    `;
    document.body.appendChild(overlay);
    
    // Setup Three.js
    scene = new THREE.Scene();
    camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.z = 5;
    
    renderer = new THREE.WebGLRenderer({ antialias: true, alpha: true });
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setClearColor(0x000000, 0);
    overlay.appendChild(renderer.domElement);
    
    const texture = new THREE.Texture(sourceImg);
    texture.needsUpdate = true;
    
    // High-quality texture settings for crisp rendering
    texture.minFilter = THREE.LinearFilter; // Better quality when scaled down
    texture.magFilter = THREE.LinearFilter; // Better quality when scaled up
    texture.anisotropy = renderer.capabilities.getMaxAnisotropy(); // Maximum anisotropic filtering
    texture.generateMipmaps = false; // Disable mipmaps for sharper image
    
    
    const imgAspect = sourceImg.naturalWidth / sourceImg.naturalHeight;
    const isMobile = window.innerWidth <= 768;
    const sizeMultiplier = isMobile ? 0.3 : 0.4;
    
    let planeWidth, planeHeight;
    if (imgAspect > 1) {
      planeWidth = 10 * sizeMultiplier;
      planeHeight = (10 * sizeMultiplier) / imgAspect;
    } else {
      planeHeight = 8 * sizeMultiplier;
      planeWidth = (8 * sizeMultiplier) * imgAspect;
    }
    
    const geometry = new THREE.PlaneGeometry(planeWidth, planeHeight, 64, 64);
    const material = new THREE.ShaderMaterial({
      uniforms: {
        map: { value: texture },
        envMap: { value: cachedEnvTexture },
        progress: { value: 0 },
        rotationSpeed: { value: 0 },
        reflectivity: { value: SETTINGS.reflectivity },
        brightness: { value: SETTINGS.imageBrightness },
        reflectionBrightness: { value: SETTINGS.reflectionBrightness },
        shineIntensity: { value: SETTINGS.shineIntensity }
      },
      vertexShader: `
        varying vec2 vUv;
        varying vec3 vNormal;
        varying vec3 vReflect;
        varying vec3 vViewPosition;
        varying float vDepth;
        
        void main() {
          vUv = uv;
          vec4 mvPosition = modelViewMatrix * vec4(position, 1.0);
          vViewPosition = -mvPosition.xyz;
          vNormal = normalize(normalMatrix * normal);
          vDepth = length(position.xy) * 0.1;
          
          vec3 worldPosition = (modelMatrix * vec4(position, 1.0)).xyz;
          vec3 cameraToVertex = normalize(worldPosition - cameraPosition);
          vec3 worldNormal = normalize(mat3(modelMatrix) * normal);
          vReflect = reflect(cameraToVertex, worldNormal);
          
          gl_Position = projectionMatrix * mvPosition;
        }
      `,
      fragmentShader: `
        uniform sampler2D map;
        uniform samplerCube envMap;
        uniform float progress;
        uniform float rotationSpeed;
        uniform float reflectivity;
        uniform float brightness;
        uniform float reflectionBrightness;
        uniform float shineIntensity;
        
        varying vec2 vUv;
        varying vec3 vNormal;
        varying vec3 vReflect;
        varying vec3 vViewPosition;
        varying float vDepth;
        
        void main() {
          vec2 parallaxOffset = vec2(vDepth * 0.02 * (vUv.x - 0.5), vDepth * 0.02 * (vUv.y - 0.5));
          vec2 adjustedUv = vUv + parallaxOffset;
          
          vec4 texColor = texture2D(map, adjustedUv);
          vec3 baseImage = texColor.rgb * brightness;
          
          if (rotationSpeed > 0.5) {
            vec2 blurOffset = vec2(rotationSpeed * 0.003, 0.0);
            vec4 blurSample1 = texture2D(map, adjustedUv + blurOffset);
            vec4 blurSample2 = texture2D(map, adjustedUv - blurOffset);
            baseImage = mix(baseImage, (blurSample1.rgb + blurSample2.rgb) * 0.5, rotationSpeed * 0.15);
          }
          
          vec3 envReflection = vec3(0.5);
          #ifdef USE_ENVMAP
            vec4 envColor = textureCube(envMap, vReflect);
            envReflection = envColor.rgb * reflectionBrightness;
          #endif
          
          float shinePos = progress * 1.8 - 0.6;
          float shineDist = abs(vUv.x - shinePos);
          float shine = smoothstep(0.25, 0.0, shineDist) * shineIntensity;
          
          vec3 viewDir = normalize(vViewPosition);
          float fresnel = pow(1.0 - abs(dot(vNormal, viewDir)), 2.5);
          
          float reflectionStrength = reflectivity + fresnel * 0.25;
          vec3 finalColor = mix(baseImage, envReflection, reflectionStrength);
          finalColor += vec3(shine);
          
          gl_FragColor = vec4(finalColor, 1.0);
        }
      `,
      defines: { USE_ENVMAP: '' }
    });
    
    const plane = new THREE.Mesh(geometry, material);
    plane.scale.set(0.01, 0.01, 0.01);
    plane.rotation.x = -0.3;
    plane.rotation.y = -0.5;
    scene.add(plane);
    
    const ambientLight = new THREE.AmbientLight(0xffffff, 0.6);
    scene.add(ambientLight);
    const directionalLight = new THREE.DirectionalLight(0xffffff, 0.8);
    directionalLight.position.set(5, 5, 5);
    scene.add(directionalLight);
    
    const startTime = Date.now();
    
    function animate() {
      const elapsed = Date.now() - startTime;
      const progress = Math.min(elapsed / SETTINGS.animationDuration, 1);
      const eased = 1 - Math.pow(1 - progress, 3);
      
      const scale = 0.01 + eased * 0.99;
      plane.scale.set(scale, scale, scale);
      plane.rotation.x = -0.3 + eased * 0.35;
      plane.rotation.y = -0.5 + eased * 0.5;
      
      const prevProgress = Math.max(0, (elapsed - 16) / SETTINGS.animationDuration);
      const prevEased = 1 - Math.pow(1 - prevProgress, 3);
      const rotationSpeed = Math.abs(eased - prevEased) * 60;
      
      material.uniforms.progress.value = progress;
      material.uniforms.rotationSpeed.value = rotationSpeed;
      
      renderer.render(scene, camera);
      
      if (progress < 1) {
        animationId = requestAnimationFrame(animate);
      } else {
        // Animation complete - navigate immediately (don't cleanup first!)
        // Overlays will stay visible during page load, then disappear when new page loads
        setTimeout(() => {
          window.location.href = productUrl;
        }, 100);
      }
    }
    
    animate();
  }
  
  function playFallbackTransition(productUrl, sourceImg) {
    // Prefetch page
    const prefetchLink = document.createElement('link');
    prefetchLink.rel = 'prefetch';
    prefetchLink.href = productUrl;
    document.head.appendChild(prefetchLink);
    
    const overlay = document.createElement('div');
    overlay.className = 'alumenarc-overlay';
    overlay.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background: #000;
      z-index: 99999;
      display: flex;
      align-items: center;
      justify-content: center;
    `;
    
    const poster = document.createElement('div');
    poster.style.cssText = `
      width: 80vw;
      height: 80vh;
      max-width: 1000px;
      max-height: 1000px;
      position: relative;
      transform: scale(0) rotateY(-45deg);
      opacity: 0;
      transition: all 1s cubic-bezier(0.34, 1.56, 0.64, 1);
    `;
    
    const img = sourceImg.cloneNode(true);
    img.style.cssText = 'width:100%;height:100%;object-fit:contain;display:block';
    
    const shine = document.createElement('div');
    shine.style.cssText = `
      position: absolute;
      top: 0;
      left: -100%;
      width: 50%;
      height: 100%;
      background: linear-gradient(90deg, transparent 0%, rgba(255,255,255,0.6) 50%, transparent 100%);
      transform: skewX(-25deg);
      pointer-events: none;
    `;
    
    poster.appendChild(img);
    poster.appendChild(shine);
    overlay.appendChild(poster);
    document.body.appendChild(overlay);
    
    requestAnimationFrame(() => {
      poster.style.transform = 'scale(1) rotateY(0deg)';
      poster.style.opacity = '1';
      shine.style.transition = 'left 1.2s cubic-bezier(0.4, 0, 0.2, 1)';
      setTimeout(() => { shine.style.left = '150%'; }, 200);
    });
    
    // Navigate after animation (don't cleanup - let overlays cover the transition)
    setTimeout(() => {
      window.location.href = productUrl;
    }, SETTINGS.animationDuration + 100);
  }
  
  function cleanup() {
    if (animationId) cancelAnimationFrame(animationId);
    if (renderer) renderer.dispose();
    
    const overlays = document.querySelectorAll('.alumenarc-overlay');
    overlays.forEach(el => el.remove());
    
    isAnimating = false;
  }

  // Back button cleanup
  window.addEventListener('pageshow', function(event) {
    if (event.persisted) {
      cleanup();
    }
  });

  waitForThree(() => {
    cachedEnvTexture = loadGoogleHDR(SETTINGS.environment);
  });

})();